<template>
  <div>
    <div class="p-3 bg-gray-06">
      <p
        class="p-3 bg-white text-14 text-center"
        data-testid="scheduledApplication"
      >
        勤務予定件数: {{ appliedApplicationCount }}件
      </p>
      <a :href="externalLink.cancel" class="mb-3">
        <p class="text-size-14 text-primary py-2 text-right">
          キャンセルについて
        </p>
      </a>
    </div>
    <div class="pt-3 px-3 pb-2">
      <ApplicationCard
        v-for="application in appliedApplications"
        :key="application.id"
        :application="application"
        class="mb-2"
        @click="$emit('clickOrderCard', application.id)"
      />

      <p
        v-if="appliedApplicationCount === 0"
        class="p-3 bg-white text-14 text-center"
        data-testid="noApplication"
      >
        お仕事はありません
      </p>
      <p v-else class="p-3 bg-white text-14 text-center" data-testid="last">
        ここが最後です
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import ApplicationCard from "@/components/organisms/applications/ApplicationCard.vue";
import { applicationStore } from "@/store/application";

@Component({
  components: {
    ApplicationCard
  }
})
export default class ApplicationsAppliedList extends Vue {
  externalLink = {
    cancel: process.env.VUE_APP_URL_CANCEL
  };

  get appliedApplications() {
    return applicationStore.appliedApplications;
  }

  get appliedApplicationCount() {
    return this.appliedApplications.length;
  }
}
</script>
